import type { DocNode as ADF } from '@atlaskit/adf-schema';
import type { MediaFile } from '@atlaskit/media-picker';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';

export const getMediaCopyIssueUrl = (issueId: number): string =>
	`/rest/api/2/attachment/upload/issue/${issueId}`;

const useAttachFile = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const attachFilesQuery = async (
		issueId: number,
		files: MediaFile[],
		comment: ADF | null | undefined,
		onSuccess: () => void,
		onFailure: () => void,
	): Promise<void> => {
		try {
			const requests = files.map(({ id }) =>
				performPostRequest(getMediaCopyIssueUrl(issueId), {
					body: JSON.stringify({
						fileId: id,
					}),
				}),
			);

			comment &&
				requests.push(
					performPostRequest(`/rest/api/3/issue/${issueId}/comment`, {
						body: JSON.stringify({ body: comment }),
					}),
				);

			await Promise.all(requests);

			fireOperationalAnalytics(
				createAnalyticsEvent({
					type: 'sendOperationalEvent',
					action: 'success',
					actionSubject: 'attachFilesQuery',
				}),
				'attachFilesQuery success',
			);
			onSuccess();
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			fireErrorAnalytics({
				error: e,
				meta: {
					id: 'attachFilesQuery',
					packageName: 'jiraIssueOperationsAttachFileDialog',
					teamName: 'empanada',
				},
			});
			onFailure();
		}
	};

	return {
		attachFilesQuery,
	};
};

export default useAttachFile;
